export const passwordAllowedSpecialCharactersRegex = /^[A-Za-z\d!#@$&_]*$/
export const phoneRegex = /^([+]\d{2} \d{3} \d{3} \d{3})$|^(\d{9})$|^([+]\d{11})$|^(\d{3} \d{3} \d{3})$|^(\d{2} \d{3} \d{2} \d{2})$/
// email regex from https://ajv.js.org/guide/formats.html
export const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i
export const postalCodeRegex = /^[0-9]{2}-[0-9]{3}$/
export const stripePublicKey = /^pk_.*/
export const stripeSecretKey = /^sk_.*/